import React from 'react'
import PropTypes from 'prop-types'
// import noop from 'lodash/noop'
import { Circles } from 'react-loader-spinner'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../constants/globalConstants'
import { getPromoName, isParksfo, formatDecimal, formatDaysHoursMinutes, isAirPort } from '../../utils/helper'



const PriceBreackupEdit = (props) => {
  const { BookingEditData, priceDetails, loaderPrice, promoCodeApply, discount, lengthPlusMinus, promoRes, selectedFacilityData, isVehicleOversize, selectedPaymentType, totalHoursLengthRef, applyPromoLoder, selectedAmenities } = props


  return (
    <div className='mt-2 '>
      {loaderPrice || applyPromoLoder ? (
        <span
          className="mx-auto my-5 d-block"
          style={{ width: '30px' }}
        >
          <Circles
            height="20"
            width="20"
            style={{ display: 'inline-block' }}
            color="#000"
            ariaLabel="circles-loading"
            visible={true}
          />
        </span>
      ) :
        priceDetails?.parking_amount == 'N/A' && lengthPlusMinus == '' ?
          selectedFacilityData?.facility_configuration?.is_process_fee_charged != '1' ? <div className="d-flex justify-content-between mb-1 ">
            <p className="m-0">Parking Amount </p>{' '}
            <p className="m-0">
              <b> {priceDetails?.parking_amount
                ? isNaN(Number(priceDetails?.parking_amount)) ? 'N/A' : formatDecimal(priceDetails?.parking_amount)
                : formatDecimal(0)}</b>
            </p>
          </div> : ''
          :
          lengthPlusMinus == '1' || priceDetails?.refundFlag=='0' ?
            <div className="px-3">
              <div className="d-flex justify-content-between mb-1 ">
                <p className="m-0">Total Parking Duration</p>{' '}
                <p className="m-0 text-end">
                  <b>
                    {formatDaysHoursMinutes(totalHoursLengthRef?.current)}
                  </b>
                </p>
              </div>
              {selectedFacilityData?.facility_configuration?.is_process_fee_charged != '1' ?
                <div className="d-flex justify-content-between mb-1 ">
                  <p className="m-0">Parking Amount</p>{' '}
                  <p className="m-0">
                    <b>
                      $
                      {priceDetails?.parking_amount
                        ? isNaN(Number(priceDetails?.parking_amount)) ? 'N/A' : formatDecimal(priceDetails?.parking_amount)
                        : formatDecimal(0)}
                    </b>
                  </p>
                </div> : ''}
              {/* EOS-5093 Amenities, shown only while the user has some selected */}
              {selectedAmenities?.length > 0 && (
                <div className="d-flex justify-content-between mb-1 ">
                  <p className="m-0 text-danger">(*Amenities fee applied)</p>{' '}
                  {/* <p className="m-0 text-danger">
                    <b>
                      $
                      {priceDetails?.amenity_fee
                        ? isNaN(Number(priceDetails?.amenity_fee)) ? 'N/A' : formatDecimal(priceDetails?.amenity_fee)
                        : formatDecimal(0)}
                    </b>
                  </p> */}
                </div>
              )}
              {priceDetails?.net_parking_amount > 0 && (
                <div className="d-flex justify-content-between mb-1 ">
                  <p className="m-0">Net Parking Amount</p>{' '}
                  <p className="m-0">
                    <b>
                      $
                      {priceDetails?.net_parking_amount
                        ? isNaN(Number(priceDetails?.net_parking_amount)) ? 'N/A' : formatDecimal(priceDetails?.net_parking_amount)
                        : formatDecimal(0)}
                    </b>
                  </p>
                </div>
              )}
              {isParksfo() ? priceDetails?.amount_paid > 0 && (
                <div className="d-flex justify-content-between mb-1 ">
                  <p className="m-0"> Amount Paid</p>{' '}
                  <p className="m-0">
                    <b>
                      ${priceDetails?.amount_paid
                        ? isNaN(Number(priceDetails?.amount_paid)) ? 'N/A' : formatDecimal(priceDetails?.amount_paid)
                        : formatDecimal(0)}
                    </b>
                  </p>
                </div>
              ) : null}
              {priceDetails?.tax_fee > 0 && (
                <div className="d-flex justify-content-between mb-1 ">
                  <p className="m-0"> {`${isParksfo() ? 'City Parking Tax' : 'Tax'}`}</p>{' '}
                  <p className="m-0">
                    <b>
                      $
                      {priceDetails?.tax_fee
                        ? isNaN(Number(priceDetails?.tax_fee)) ? 'N/A' : formatDecimal(priceDetails?.tax_fee)
                        : formatDecimal(0)}
                    </b>
                  </p>
                </div>
              )}
              {priceDetails?.surcharge_fee > 0 && (
                <div className="d-flex justify-content-between mb-1 ">
                  <p className="m-0"> {`${isParksfo() ? 'Fuel Surcharge Fee' : 'Surcharge Fee'}`}</p>{' '}
                  <p className="m-0">
                    <b>
                      $
                      {priceDetails?.surcharge_fee
                        ? formatDecimal(priceDetails?.surcharge_fee)
                        : formatDecimal(0)}
                    </b>
                  </p>
                </div>
              )}
              {(Number(priceDetails?.additional_fee) > 0 || Number(BookingEditData?.additional_fee) > 0) && isParksfo() ? (
                <div className="d-flex justify-content-between mb-1 ">
                  <p className="m-0"> Airport Access fee</p>{' '}
                  <p className="m-0">
                    <b>
                      $
                      {priceDetails?.additional_fee
                        ? formatDecimal(priceDetails?.additional_fee)
                        : formatDecimal(0)}
                    </b>
                  </p>
                </div>
              ) : null}
              {priceDetails?.processing_fee > 0 && isParksfo() ? (
                <div className="d-flex justify-content-between mb-1 ">
                  <p className="m-0"> {isAirPort() ? 'Airport Access Fee' : 'Processing Fee'}</p>{' '}
                  <p className="m-0">
                    <b>
                      $
                      {priceDetails?.processing_fee
                        ? formatDecimal(priceDetails?.processing_fee)
                        : formatDecimal(0)}
                    </b>
                  </p>
                </div>
              ) : null}
              {((priceDetails?.processing_fee && priceDetails?.processing_fee > 0) || (priceDetails?.additional_fee && priceDetails?.additional_fee > 0)) && !isParksfo() ? (
                <div className="d-flex justify-content-between mb-1 ">
                  <p className="m-0"> {selectedFacilityData?.facility_configuration?.is_process_fee_charged == '1' ? 'Reservation Fee' : 'Processing Fee'}  </p>{' '}
                  <p className="m-0">
                    <b>
                      ${isParksfo() ? formatDecimal(priceDetails?.processing_fee || '0') : formatDecimal(Number(priceDetails?.processing_fee || '0') + Number(priceDetails?.additional_fee || '0'))}
                    </b>
                  </p>
                </div>
              ) : null}
              
              <div className='border-top '>
                {(promoCodeApply && Number(discount) > 0) ? (
                  <>
                    <div className="d-flex justify-content-between mb-1 ">
                      <p className='m-0'>{promoRes?.promocode?.discount_type == 'hours' ? `Validated Amount (${promoRes?.discount_in_hours} Hrs Free)` : selectedFacilityData?.facility_configuration?.enable_third_party_coupons == '1' ? 'Coupon Discount' : 'Discount'} </p>{' '}

                      <p className="m-0">
                        {/* <b>- ${parseFloat(discount).toFixed(2)}</b> */}
                        <b>- ${discount ? formatDecimal(discount) : '-'}</b>

                      </p>
                    </div>
                    {selectedFacilityData?.facility_configuration?.enable_third_party_coupons == 1 && getPromoName(priceDetails, promoRes) ? 
                    <p className='small'>
                      ({getPromoName(priceDetails, promoRes)})
                    </p> : null}
                  </>
                ) : null }
                {!isParksfo() ? priceDetails?.amount_paid > 0 && (
                  <div className="d-flex justify-content-between mb-1 ">
                    <p className="m-0"> Amount Paid</p>{' '}
                    <p className="m-0">
                      <b>
                        ${priceDetails?.amount_paid
                          ? isNaN(Number(priceDetails?.amount_paid)) ? 'N/A' : formatDecimal(priceDetails?.amount_paid)
                          : formatDecimal(0)}
                      </b>
                    </p>
                  </div>
                ): null}


              </div>
              {isVehicleOversize && <div className="row">
                <small className="text-danger small col-8 d-block">
                  <span className="text-danger small d-block p-0 m-0">(**Oversize Fee Applied)</span>
                </small>
              </div>}
              <div className="d-flex  justify-content-between mb-1 pt-2 ">

                <h5 className="font-weight-bold text-primary m-0 ">
                  {(selectedPaymentType == 0 && isParksfo()) ? 'Estimated Total' : selectedFacilityData?.facility_configuration?.is_process_fee_charged == '1' ? 'Total Due' : 'Amount Due'}
                </h5>
                {selectedFacilityData?.facility_configuration?.is_process_fee_charged == '1' ?
                  <h5 className="font-weight-bold text-primary ">
                    $
                    {priceDetails?.processing_fee
                      ? isNaN(Number(priceDetails?.processing_fee)) ? 'N/A' : formatDecimal(priceDetails?.processing_fee)
                      : formatDecimal(0)}{' '}
                  </h5> :
                  <h5 className="font-weight-bold text-primary ">
                    $
                    {priceDetails?.payable_amount
                      ? isNaN(Number(priceDetails?.payable_amount)) ? 'N/A' : formatDecimal(priceDetails?.payable_amount)
                      : (selectedPaymentType == 0 && isParksfo()) ? formatDecimal(priceDetails?.payable_amount || priceDetails?.total) : formatDecimal(0)}{' '}
                  </h5>}

              </div>


            </div>
            :
            <div className="px-3">
              <div className="d-flex justify-content-between mb-1 ">
                <p className="m-0">Total Parking Duration</p>{' '}
                <p className="m-0 text-end">
                  <b>
                    {formatDaysHoursMinutes(totalHoursLengthRef?.current)}
                  </b>
                </p>
              </div>
              {/* refund & normal edit case*/}
              {selectedFacilityData?.facility_configuration?.is_process_fee_charged != '1' ? <div className="d-flex justify-content-between mb-1 ">
                <p className="m-0">Parking Amount</p>{' '}
                <p className="m-0">
                  <b>
                    $
                    {BookingEditData?.parking_amount
                      ? isNaN(Number(BookingEditData?.parking_amount)) ? 'N/A' : formatDecimal(BookingEditData?.parking_amount)
                      : formatDecimal(0)}
                  </b>
                </p>
              </div> : ''}
              {/* EOS-5093 Amenities, shown only while the user has some selected */}
              {selectedAmenities?.length > 0 && (
                <div className="d-flex justify-content-between mb-1 ">
                   <p className="m-0 text-danger">(*Amenities fee applied.)</p>{' '}
                  {/* <p className="m-0 text-danger">
                    <b>
                      $
                      {formatDecimal(BookingEditData?.amenity_fee || priceDetails?.amenity_fee || 0)}
                    </b>
                  </p> */}
                </div>
              )}
              {isParksfo() ? (BookingEditData?.transaction && BookingEditData?.total > 0) && (<div className="d-flex justify-content-between mb-1 ">
                <p className="m-0 ">
                  Amount Paid
                </p>
                {<b className="m-0">
                  $ {BookingEditData?.total}{' '}
                </b>}
              </div>
              ) : null}
              {priceDetails?.net_parking_amount > 0 && (
                <div className="d-flex justify-content-between mb-1 ">
                  <p className="m-0">Net Parking Amount</p>{' '}
                  <p className="m-0">
                    <b>
                      $
                      {priceDetails?.net_parking_amount
                        ? isNaN(Number(priceDetails?.net_parking_amount)) ? 'N/A' : formatDecimal(priceDetails?.net_parking_amount)
                        : formatDecimal(0)}
                    </b>
                  </p>
                </div>
              )}
              {BookingEditData?.tax_fee > 0 && (
                <div className="d-flex justify-content-between mb-1 ">
                  <p className="m-0"> {`${isParksfo() ? 'City Parking Tax' : 'Tax'}`}</p>{' '}
                  <p className="m-0">
                    <b>
                      $
                      {BookingEditData?.tax_fee
                        ? isNaN(Number(BookingEditData?.tax_fee)) ? 'N/A' : formatDecimal(BookingEditData?.tax_fee)
                        : formatDecimal(0)}
                    </b>
                  </p>
                </div>
              )}
              
              {((BookingEditData?.processing_fee && BookingEditData?.processing_fee > 0) || (BookingEditData?.additional_fee && BookingEditData?.additional_fee > 0) && !isParksfo()) && (
                <div className="d-flex justify-content-between mb-1 ">
                  <p className="m-0"> {selectedFacilityData?.facility_configuration?.is_process_fee_charged == '1' ? 'Reservation Fee' : isAirPort() ? 'Airport Access Fee' : 'Processing Fee'}  </p>{' '}
                  <p className="m-0">
                    <b>
                      ${isParksfo() ? formatDecimal(BookingEditData?.processing_fee || 0) : formatDecimal(Number(BookingEditData?.processing_fee) + Number(BookingEditData?.additional_fee))}
                    </b>
                  </p>
                </div>
              )}
              

              {Number(BookingEditData?.surcharge_fee > 0) ? (
                <div className="d-flex justify-content-between mb-1 ">
                  <p className="m-0"> {`${isParksfo() ? 'Fuel Surcharge Fee' : 'Surcharge Fee'}`}</p>
                  <p className="m-0">
                    <b>
                      $
                      {BookingEditData?.surcharge_fee
                        ? formatDecimal(BookingEditData?.surcharge_fee)
                        : formatDecimal(0)}
                    </b>
                  </p>
                </div>
              ) : null}

              {(Number(BookingEditData?.additional_fee) > 0) && isParksfo() ? (
                <div className="d-flex justify-content-between mb-1 ">
                  <p className="m-0"> Airport Access fee</p>{' '}
                  <p className="m-0">
                    <b>
                      $
                      {priceDetails?.additional_fee
                        ? formatDecimal(priceDetails?.additional_fee) : BookingEditData?.additional_fee ? formatDecimal(BookingEditData?.additional_fee)
                        : formatDecimal(0)}
                    </b>
                  </p>
                </div>
              ) : null }

              {priceDetails?.discount_amount > 0 ? (
                <>
                  <div className="d-flex justify-content-between mb-1 ">
                    <p className="m-0">{promoRes?.promocode?.discount_type == 'hours' ? `Validated Amount (${promoRes?.discount_in_hours} Hrs Free)` : selectedFacilityData?.facility_configuration?.enable_third_party_coupons == '1' ? 'Coupon Discount' : 'Discount'}</p>{' '}
                    <p className="m-0">
                      <b>- ${formatDecimal(priceDetails?.discount_amount)}</b>
                    </p>
                  </div>
                  {selectedFacilityData?.facility_configuration?.enable_third_party_coupons == 1 && getPromoName(priceDetails, promoRes) ? 
                  <p className='small'>
                    ({getPromoName(priceDetails, promoRes)})
                  </p> : null}
                </>
              ) : null}

              {!isParksfo() ? BookingEditData?.total > 0 && (<div className="d-flex justify-content-between mb-1 ">
                <p className="m-0 ">
                  Amount Paid
                </p>
                {<b className="m-0">
                  $ {formatDecimal(BookingEditData?.total)}{' '}
                </b>}
              </div>
              ) : null}
              
              {Number(priceDetails?.refund_amount) > 0 && selectedFacilityData?.facility_configuration?.is_process_fee_charged != '1' ? <div className="d-flex border-top justify-content-between mb-1 pt-2 ">
                <h5 className="font-weight-bold text-primary m-0 ">
                  Refund Amount
                </h5>
                {<h5 className="font-weight-bold text-primary ">
                  $ {isNaN(Number(priceDetails?.refund_amount)) ? 'N/A' : formatDecimal(priceDetails?.refund_amount)}{' '}
                </h5>}
              </div> :
              <> {isVehicleOversize && <div className="row">
                <small className="text-danger small col-8 d-block">
                  <span className="text-danger small d-block p-0 m-0">(**Oversize Fee Applied)</span>
                </small>
              </div>}
                <div className="d-flex  justify-content-between mb-1 pt-2 ">
              
               {isParksfo() && <>  <h5 className="font-weight-bold text-primary m-0 ">
                    {(selectedPaymentType == 0 && isParksfo()) ? 'Estimated Total' : selectedFacilityData?.facility_configuration?.is_process_fee_charged == '1' ? 'Total Due' : 'Amount Due'}
                  </h5>
                  {selectedFacilityData?.facility_configuration?.is_process_fee_charged == '1' ?
                    <h5 className="font-weight-bold text-primary ">
                      $
                      {BookingEditData?.processing_fee
                        ? isNaN(Number(BookingEditData?.processing_fee)) ? 'N/A' : formatDecimal(BookingEditData?.processing_fee)
                        : formatDecimal(0)}
                    </h5> :
                    <h5 className="font-weight-bold text-primary ">
                      $
                      {priceDetails?.payable_amount
                        ? isNaN(Number(priceDetails?.payable_amount)) ? 'N/A' : formatDecimal(priceDetails?.payable_amount)
                        : (selectedPaymentType == 0 && isParksfo()) ? formatDecimal(priceDetails?.payable_amount || priceDetails?.total) : formatDecimal(0)}
                    </h5>}
                    </>}

                    {!isParksfo() ? <h5 className="font-weight-bold text-primary m-0 ">
                      {selectedFacilityData?.facility_configuration?.is_process_fee_charged == '1' ? 'Total Due' : 'Amount Due'}
                    </h5> : null}
                    {!isParksfo() ? selectedFacilityData?.facility_configuration?.is_process_fee_charged == '1' ?
                      <h5 className="font-weight-bold text-primary ">
                        $
                        {BookingEditData?.processing_fee
                          ? isNaN(Number(BookingEditData?.processing_fee)) ? 'N/A' : formatDecimal(BookingEditData?.processing_fee)
                          : formatDecimal(0)}
                      </h5> :
                      <h5 className="font-weight-bold text-primary ">
                        $
                        {priceDetails?.payable_amount
                          ? isNaN(Number(priceDetails?.payable_amount)) ? 'N/A' : formatDecimal(priceDetails?.payable_amount)
                          : formatDecimal(0)}
                      </h5> : null}

                  </div>
                </>
              }
            </div>

      }
    </div>
  )
}

PriceBreackupEdit.propTypes = {
  loaderPrice: PropTypes.bool,
  priceDetails: PropTypes.object,
  discount: PropTypes.func,
  promoCodeApply: PropTypes.bool,
  timeupdate: PropTypes.bool,
  BookingEdit: PropTypes.bool,
  BookingEditData: PropTypes.object,
  lengthPlusMinus: PropTypes.string,
  promoRes: PropTypes.object,
  selectedFacilityData: PropTypes.object,
  isVehicleOversize: PropTypes.bool,
  selectedPaymentType: PropTypes.arrayOf([PropTypes.string, PropTypes.number]),
  totalHoursLengthRef: PropTypes.arrayOf([PropTypes.string, PropTypes.number]),
  applyPromoLoder: PropTypes.bool,
  selectedAmenities: PropTypes.array,
}

PriceBreackupEdit.defaulProps = {
  loaderPrice: false,
  priceDetails: EMPTY_OBJECT,
  discount: '',
  promoCodeApply: false,
  timeupdate: false,
  BookingEdit: false,
  BookingEditData: EMPTY_OBJECT,
  lengthPlusMinus: '',
  promoRes: EMPTY_OBJECT,
  selectedFacilityData: EMPTY_OBJECT,
  isVehicleOversize: false,
  selectedPaymentType: null,
  totalHoursLengthRef: null,
  applyPromoLoder: false,
  selectedAmenities: EMPTY_ARRAY,
}

export default PriceBreackupEdit
